export default "__VITE_ASSET__DIVsXtiN__"